import { router } from '../router'

export const noAuth = () => router.push({ name: 'login' })



// WEBPACK FOOTER //
// ./src/lib/errors.js